import {Event} from './Events';
import {Timestamp} from './Time';

export type OwnerPayment = {
  id: Maybe<number>;
  owner_id: Maybe<number>;
  payout_date: Maybe<string>;
  payout_amount: Maybe<number>;
  payout_type: Maybe<string>;
  lob_id: Maybe<string>;
  lob_json: Maybe<LobResponseJson>;
  paypal_id: Maybe<string>;
  paypal_status: Maybe<string>;
  paypal_response: unknown;
  gift_card_id: Maybe<string>;
  gift_card_json: Maybe<ShopifyGiftCardResponseJson>;
  created_at: Maybe<string>;
  updated_at: Maybe<string>;
  owner_payment_items: OwnerPaymentItem[];
};
export type OwnerPaymentItem = {
  id: Maybe<number>;
  item_description_id: Maybe<number>;
  quantity: Maybe<number>;
  payout_amount: Maybe<number>;
  item_sale_ids: Maybe<number[]>;
};
export const EMPTY_OWNER_PAYMENT: OwnerPayment = {
  id: null,
  owner_id: null,
  payout_date: null,
  payout_amount: null,
  payout_type: null,
  lob_id: null,
  paypal_id: null,
  paypal_status: null,
  paypal_response: null,
  lob_json: null,
  created_at: null,
  updated_at: null,
  owner_payment_items: [],
  gift_card_id: null,
  gift_card_json: null,
};
export const EMPTY_OWNER_PAYMENT_ITEM: OwnerPaymentItem = {
  id: null,
  item_description_id: null,
  quantity: null,
  payout_amount: null,
  item_sale_ids: [],
};
export type CashOutEvent = Event<
  'cashOut',
  {
    id: Maybe<number>;
    payment_preference?: Maybe<string>;
    paypal_email?: Maybe<string>;
    payment_name?: Maybe<string>;
    gift_card_email?: Maybe<string>;
    location?: Maybe<{
      address?: Maybe<string>;
      address_line_2?: Maybe<string>;
      city?: Maybe<string>;
      state?: Maybe<string>;
      zipcode?: Maybe<string>;
    }>;
    merchantOrderItemIds?: Maybe<number[]>;
  }
>;
export type CancelOwnerPaymentEvent = Event<
  'cancelOwnerPayment',
  {owner_payment_id: number},
  {ownerPayment: OwnerPayment}
>;
export type LobResponseJson = {
  id: string;
  amount: number;
  url: string;
  to_be_expunged_date?: string;
};
export type ShopifyGiftCardResponseJson = {
  id: string;
  initialValue: number;
  customerId?: string;
  note?: string;
  expiresOn?: Timestamp;
  giftCardCode: string;
};
export const GIFT_CARD_FACTOR = 1.1;
export function calculateGiftCardCashoutValue(cashoutAmount: number): number {
  return Math.round(cashoutAmount * GIFT_CARD_FACTOR);
}
